import React, { useEffect, useReducer, useState } from 'react';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import { constants } from '../misc/constants';
import { ClosedCaptionManager } from '../cvp-webgames-core/ClosedCaptionManager';
import ReactCaption from '../cvp-webgames-core/Components/general/react/ReactCaption';
import TopLeftControlsUI, { TopLeftControlsUIConfig } from './ui/hud/top-left-controls-ui';
import CoreReturnToMainMenuUI, { CoreReturnToMainMenuUIConfig } from '../cvp-webgames-core/Components/ui/react/core-return-to-main-menu-ui';
import QuestionType1UI, { QuestionType1UIConfig } from './ui/question-type1-ui';
import FeedbackUI, { FeedbackUIConfig } from './ui/feedback-ui';
import QuestionType2UI, { QuestionType2UIConfig } from './ui/question-type2-ui';
import AlertUI, { AlertUIConfig } from './ui/alert-ui';
import SkipContentUI, { SkipContentUIConfig } from './ui/skip-content-ui';
import IntroScreenUI, { IntroScreenUIConfig } from './ui/intro-screen-ui';
import { SingleUI } from '../cvp-webgames-core/Components/ui/react/base/SingleUI';
import { PageType, TextHtmlTagType, getGlobalTextSizeStyle, getSaveData, parseDynamicHtml } from '../misc/tools';
import CoreResumeUI, { CoreResumeUIConfig } from '../cvp-webgames-core/Components/ui/react/core-resume-ui';
import MixedMediaUI, { MixedMediaUIConfig } from './ui/mixed-media';
import Tools from '../cvp-webgames-core/Misc/Tools';
import LoadingUI from '../cvp-webgames-core/Components/ui/react/loading-ui';
import ScenarioInfoUI from './ui/scenario-info-ui';

const reducer = (state: any, action: any) => {
	return state;
};

let ccManager: ClosedCaptionManager = null;
const UIOverlay = (props: any) => {
	const [uisRegistered, setUisRegistered] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		uiProps: null,
		gameManager: props.gameManager
	});


	useEffect(() => {
		$(window).resize();

		if (uisRegistered) {
			return;
		}

		(window as any)['ui-force-update'] = () => {
			const updateAllElements = (cls: string, tagType: TextHtmlTagType, parent: HTMLElement) => {
				const els: any = parent ? parent.getElementsByTagName('p') : document.querySelectorAll(cls);
				for(var indx = 0; indx < els.length; indx++) {
					let el: HTMLElement = els[indx];
					el.style.fontSize = getGlobalTextSizeStyle(tagType).fontSize
					if(tagType === TextHtmlTagType.p) {
						updateAllElements(null, tagType, el);
					}
				}
			}

			updateAllElements('.text-manual-edit-h1', TextHtmlTagType.h1, null);
			updateAllElements('.text-manual-edit-h2', TextHtmlTagType.h2, null);
			updateAllElements('.text-manual-edit-p', TextHtmlTagType.p, null);


			(window as any)['ui-force-update-reloadable']();
		}

		setUisRegistered(true);

		let uiManager = props.gameManager.UiManager as JsxUIManager;

		uiManager.registerUI(constants.uiNames.FeedbackUI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							onButtonClicked: () => {

							},
							selectedOption: {
								title: 'Option 4',
								description: 'Hi Jared, thank you for meeting with me. I understand there was a patient fall. Can you tell me what happened?',
								feedbackHtml: `
									<p class="default-text">Best answer. This response shows respect to the employee by thanking them for meeting with you, asking how they 
									are doing demonstrates your concern for them as a second victim. Asking “what” happened versus “why” the incident occurred 
									opens the dialogue and reinforces a culture of safety.</p>
								`,
								isCorrect: true,
								score: 5
							},
							subtitle: 'Debug Step',
							title: 'Debug Scenario'
						} as FeedbackUIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <FeedbackUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></FeedbackUI>
			}
		});

		uiManager.registerUI(constants.uiNames.IntroScreenUI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							htmlData: `
								<p class="default-text">Patient Safety Event / Incident Report</p>
								<ul>
									<li class="default-text"><p>Reporter: <br /><br />
									Report recieved via shift hand off report from the off tour supervisor</p></li>
									<li class="default-text"><p>When did the event occur? <br /><br />
									Two days ago over the weekend</p></li>
									<li class="default-text"><p>Where did the event occur?<br /><br />
									In the new MRI unit</p></li>
									<li class="default-text"><p>Event Description:<br /><br />
									A floor buffer got stuck in the brand new MRI unit. No one was available over the 
									weekend who knew how to operate the MRI machine. The nursing supervisor noticed the red “stop” button and 
									quenched the MRI machine. The result of the quench caused the MRI unit to be out of order for another several 
									weeks and several thousands of dollars to repair.
									</p></li>
								</ul>
							`,
							title: 'Demo Scenario',
							onStartScenarioClicked: () => {

							}
						} as IntroScreenUIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <IntroScreenUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></IntroScreenUI>
			}
		});

		uiManager.registerUI(constants.uiNames.MixedMediaUI, {
			debugUITemplate: [
				
			],
			renderMethod: (instance: any) => {
				return <MixedMediaUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></MixedMediaUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ScenarioInfoUI, {
			debugUITemplate: [
				
			],
			renderMethod: (instance: any) => {
				return <ScenarioInfoUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ScenarioInfoUI>
			}
		});

	}, [state]);
	return state.gameManager && state.gameManager.environment && state.gameManager.environment.isReady ? (
		<div className="in-game-overlay-container in-game-ui-container ui-container-root modal-disable-select">
			<SingleUI id={constants.uiNames.FeedbackUI} uiManager={props.gameManager.UiManager}></SingleUI>
			<SingleUI id={constants.uiNames.MixedMediaUI} uiManager={props.gameManager.UiManager}></SingleUI>
			<SingleUI id={constants.uiNames.ScenarioInfoUI} uiManager={props.gameManager.UiManager}></SingleUI>
			<SingleUI id={constants.uiNames.IntroScreenUI} uiManager={props.gameManager.UiManager}></SingleUI>
			<ReloadableComponents updateWindow={props.updateWindow} gameManager={props.gameManager} scenarioId={props.scenarioId} forceUpdate={() => {
					props.forceUpdate()
			}} hideAllUIs={props.hideAllUIs}></ReloadableComponents>
		</div>
	) : (null);
};

const ReloadableComponents = (props: any) => {
	const [uisRegistered, setUisRegistered] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		uiProps: null,
		gameManager: props.gameManager
	});

	let isDisplayingHeader = false;

	(window as any).setCCManager = (ccM: any) => {
		ccManager = ccM;
		(window as any).forceUpdateInternalCCComp();
		// if((window as any).onCaptionsChanged) {
		//     (window as any).onCaptionsChanged();
		// }
	}

	(window as any)['ui-force-update-reloadable'] = () => {
		setForceUpdate(!forceUpdate);
	}


	useEffect(() => {
		$(window).resize();

		if (uisRegistered) {
			return;
		}

		(window as any)['forceEntireUIRefresh'] = () => {
			setForceUpdate(!forceUpdate);
		}

		setUisRegistered(true);

		let uiManager = props.gameManager.UiManager as JsxUIManager;

		uiManager.registerGeneralUIs();

		uiManager.registerUI(constants.uiNames.TopLeftControlsUI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							onAudioToggled: () => {

							},
							onForceRefreshEntireUI: () => {

							},
							onReturnToMenuClicked: () => {

							},
							onToggleCC: () => {

							},
							onTogglePause: () => {

							}
						} as TopLeftControlsUIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <TopLeftControlsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></TopLeftControlsUI>
			}
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.LoadingUI, {
			debugUITemplate: [
			],
			renderMethod: (instance: any) => {
				return <LoadingUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></LoadingUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ResumeUI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
						} as CoreResumeUIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <CoreResumeUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></CoreResumeUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ReturnToMainMenuUI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							onCancelClicked: () => {

							},
							onGoToMainMenuClicked: () => {

							}
						} as CoreReturnToMainMenuUIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <CoreReturnToMainMenuUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></CoreReturnToMainMenuUI>
			}
		});

		uiManager.registerUI(constants.uiNames.QuestionType1UI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							title: ("Debug Scenario" as PageType),
							multipleChoice: false,
							percentage: 0.2,
							subtitle: "Debug Step",
							questionTitle: 'Which option is the best to begin the meeting with the employee?',
							options: [
								{
									title: 'Option 1',
									description: 'Hi Jared, thank you for meeting with me. Why did the patient fall?',
									feedbackHtml: `
										<p class="default-text">This response is not the best because asking the question in this way creates an environment of looking for blame. 
										Asking what happened is the first step. </p>
									`,
									isCorrect: false,
									score: 0
								},
								{
									title: 'Option 2',
									description: 'Hi Jared, thank you for meeting with me. You know we’re focused on zero harm. Why did your patient fall?',
									feedbackHtml: `
										<p class="default-text">This response is not the best because asking the question in this way creates an environment of looking for blame. 
										Asking what happened is the first step. </p>
									`,
									isCorrect: false,
									score: 0
								},
								{
									title: 'Option 3',
									description: 'Hi Jared, I’m assuming you know why I called to meet you.',
									feedbackHtml: `
										<p class="default-text">This response is not the best because it lacks showing respect for the employee and is not the best for 
										establishing psychological safety.</p>
									`,
									isCorrect: false,
									score: 0
								},
								{
									title: 'Option 4',
									description: 'Hi Jared, thank you for meeting with me. I understand there was a patient fall. Can you tell me what happened?',
									feedbackHtml: `
										<p class="default-text">Best answer. This response shows respect to the employee by thanking them for meeting with you, asking how they 
										are doing demonstrates your concern for them as a second victim. Asking “what” happened versus “why” the incident occurred 
										opens the dialogue and reinforces a culture of safety.</p>
									`,
									isCorrect: true,
									score: 5
								}
							],

							onSubmitClicked: () => {

							}
						} as QuestionType1UIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <QuestionType1UI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></QuestionType1UI>
			}
		});

		uiManager.registerUI(constants.uiNames.QuestionType2UI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							correctFeedback: `
								<p class="default-text">waiting for final content</p>
							`,
							isYesCorrect: true,
							onSubmitClicked: () => {

							},
							question: 'Are there repeated errors, or occurrences of at-risk behavior?',
							subtitle: 'Demo Step',
							title: ("Demo Scenario" as PageType),
							wrongFeedback: `
							<p class="default-text">waiting for final content</p>
						`,
							onReplayContentClicked: () => {

							}
						} as QuestionType2UIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <QuestionType2UI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></QuestionType2UI>
			}
		});

		uiManager.registerUI(constants.uiNames.AlertUI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							htmlContent: `
								<p class="default-text">This is a sample alert</p>
							`,
							okButton: {
								onClick: () => {

								},
								title: 'OK'
							},
							title: "Demo Alert"
						} as AlertUIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <AlertUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></AlertUI>
			}
		});

		uiManager.registerUI(constants.uiNames.SkipContentUI, {
			debugUITemplate: [
				{
					name: 'Default',
					debugUITemplate: () => {
						return {
							onSkipContentClicked: () => {

							}
						} as SkipContentUIConfig
					}
				}
			],
			renderMethod: (instance: any) => {
				return <SkipContentUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SkipContentUI>
			}
		});

	}, [state]);
	return state.gameManager && state.gameManager.environment && state.gameManager.environment.isReady ? (
		<div className="in-game-overlay-container in-game-ui-container ui-container-root modal-disable-select">
			{/* {props.gameManager.UiManager.render()} */}
			{props.gameManager.SoundManager.render()}
			{props.hideAllUIs ? (
				<div>

				</div>
			) : (
				<div>
					<div id={'main-content-top'} tabIndex={0} style={{ position: 'absolute', top: '0', left: '0' }}></div>
					<SingleUI id={constants.uiNames.TopLeftControlsUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.ResumeUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.QuestionType1UI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.QuestionType2UI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.ReturnToMainMenuUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.AlertUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.SkipContentUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.LoadingUI} uiManager={props.gameManager.UiManager}></SingleUI>
					{(props.gameManager.UiManager as JsxUIManager).renderSingleGeneralUIs()}
					<div id={'main-content-bottom'} tabIndex={0} style={{ position: 'absolute', top: '0', left: '0' }}></div>
				</div>
			)}

			<InternalCaptionComp></InternalCaptionComp>
		</div>
	) : (null);
};

export default UIOverlay;

const InternalCaptionComp = () => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const [isExpanded, setIsExpanded] = useState(true);

	(window as any).CCEnabled = getSaveData().isClosedCaptionEnabled;
	(window as any).forceUpdateInternalCCComp = () => {
		setForceUpdate(!forceUpdate);
	}

	if (typeof (window as any).CCEnabled === 'undefined') {
		(window as any).CCEnabled = true;
	}
	return ccManager ? (
		<div>
			{<ReactCaption
				currentCaption={ccManager.currentCaption}
				isPaused={ccManager.isPaused}
			></ReactCaption>}
			{ccManager && ccManager.currentCaption && !ccManager.isPaused && <div className="caption-container">
				{(window as any).CCEnabled &&
					<div className="caption-block" style={{
						'left': isExpanded ? '0' : '-100%',
						pointerEvents: 'all',
						transform: 'unset',
						...(Tools.isios() ? {
							bottom: '40px'
						} : {})
					}}>
						<p className="caption-paragraph" dangerouslySetInnerHTML={{ __html: parseDynamicHtml(ccManager.currentCaption) }}>
						</p>
						<div className='collapse-bttn' style={{
						'left': isExpanded ? '0' : '100%',
						pointerEvents: 'all',
						transform: 'unset'
					}}tabIndex={0} aria-label='Toggle Captions' onKeyUp={Tools.mapDivEnterToClick} onClick={() => {
							setIsExpanded(!isExpanded);
						}}>
							<img alt={isExpanded ? 'Closed Captions (On)' : 'Closed Captions (Off)'} className="cc-img center-element make-white" src={ isExpanded ? (process.env.PUBLIC_URL + '/assets/images/closed-captioning-on.svg') : (process.env.PUBLIC_URL + '/assets/images/closed-captioning-off.svg')} />
						</div>
					</div>
				}
			</div>
			}

		</div>
	) : (null);

};